export const GET_NOTIFICATIONS_DATA = 'GET_NOTIFICATIONS_DATA'
export const UPDATE_NOTIFICATIONS_DATA = 'UPDATE_NOTIFICATIONS_DATA'
